import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { getVipTiers } from 'restaurantAdmin/settings/general/vipProgramSection/apiHelpers';
import { useQuery } from '@tanstack/react-query';

export const vipTiersQueryKey = (restaurantId: string) =>
  ['restaurants', restaurantId, 'vipTiers'] as const;

export const useVipTiers = () => {
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: vipTiersQueryKey(restaurantId),
    queryFn: async () => getVipTiers(restaurantId),
    initialData: [],
    select: (data) => [...data].sort((a, b) => a.index - b.index),
  });
};
